<template>
    <div class="items-to-pull glass-theme">
        <!-- API Loading Overlay with Animation -->
        <transition name="loading-overlay">
            <div v-if="apiLoading" class="loading-overlay">
                <div class="loading-card">
                    <div class="loading-animation">
                        <div class="loading-ring">
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="ring"></div>
                            <div class="loading-logo">
                                <i class="fas fa-boxes"></i>
                            </div>
                        </div>
                    </div>
                    <div class="loading-text">
                        <h3>{{ loadingMessage }}</h3>
                        <div class="loading-dots">
                            <span class="dot"></span>
                            <span class="dot"></span>
                            <span class="dot"></span>
                        </div>
                    </div>
                    <div class="loading-progress">
                        <div class="progress-bar" :style="{ width: loadingProgress + '%' }"></div>
                    </div>
                    <div class="loading-tips">
                        <p class="tip-text">{{ currentTip }}</p>
                    </div>
                </div>
            </div>
        </transition>

        <div>
            <div>
                <b-modal id="modal-itp-comments" scrollable size="md" hide-footer :title="'COMMENTS FOR ('+item_comments_invoice_id+')'">
                    <ItemComments :viewdata="{invoice_id: item_comments_invoice_id, itemid: item_comments_itemid, username: packet.userDetails.username}" />
                </b-modal>

                <div style="width: 100%;">
                    <div>
                        <div
                          v-if="isMobile"
                          class="d-flex justify-content-between align-items-center mb-2 px-1"
                        >
                          <b-button
                            size="sm"
                            variant="outline-primary"
                            @click="filtersVisible = !filtersVisible"
                          >
                            <b-icon-funnel-fill class="mr-1"></b-icon-funnel-fill>
                            {{ filtersVisible ? 'Hide Filters' : 'Show Filters' }}
                          </b-button>
                        </div>

                        <b-collapse :visible="!isMobile || filtersVisible" class="mb-2">
                          <b-alert variant="secondary" show class="filter-container glass-card">
                            <div class="filter-row">
                              <!-- Date Range Selection -->
                              <div class="filter-group">
                                <div class="filter-label">SELECT DATE RANGE</div>
                                <date-picker
                                  v-model="dateRange"
                                  range
                                  placeholder="Select start and end date"
                                  value-type="format"
                                  format="YYYY-MM-DD"
                                  :clearable="false"
                                  class="filter-datepicker glass-input"
                                ></date-picker>
                              </div>

                              <!-- Status Selection -->
                              <div class="filter-group" v-if="dateRange && dateRange.length === 2">
                                <div class="filter-label">SELECT A STATUS</div>
                                <b-form-select
                                  size="lg"
                                  :options="statusOptions"
                                  v-model="selectedStatus"
                                  class="filter-select glass-select"
                                >
                                  <template #first>
                                    <b-form-select-option :value="null">SELECT STATUS</b-form-select-option>
                                  </template>
                                </b-form-select>
                              </div>

                              <!-- Secondary Filters -->
                              <div class="filter-group" v-if="items.length > 0 && selectedStatus !== null">
                                <div class="filter-label">FILTER BY DATES</div>
                                <b-form-select
                                  size="lg"
                                  :options="filter_dates()"
                                  v-model="picked_date"
                                  class="filter-select glass-select"
                                  @change="applyDateFilter"
                                >
                                  <template #first>
                                    <b-form-select-option :value="null">ALL DATES</b-form-select-option>
                                  </template>
                                </b-form-select>
                              </div>

                              <div class="filter-group" v-if="items.length > 0 && selectedStatus !== null">
                                <div class="filter-label">FILTER PULL LOCATION</div>
                                <b-form-select
                                  size="lg"
                                  :options="filter_locations()"
                                  v-model="picked_location_id"
                                  class="filter-select-wide glass-select"
                                  @change="applyLocationFilter"
                                >
                                  <template #first>
                                    <b-form-select-option :value="null">ALL LOCATIONS</b-form-select-option>
                                  </template>
                                </b-form-select>
                              </div>

                              <div class="filter-group" v-if="items.length > 0 && selectedStatus !== null">
                                <div class="filter-label">FILTER ORDER TYPE</div>
                                <b-form-select
                                  size="lg"
                                  :options="filter_order_types()"
                                  v-model="picked_order_type"
                                  class="filter-select glass-select"
                                  @change="applyOrderTypeFilter"
                                >
                                  <template #first>
                                    <b-form-select-option :value="null">ALL TYPES</b-form-select-option>
                                  </template>
                                </b-form-select>
                              </div>

                              <!-- Download Button -->
                              <div class="filter-group" v-if="items.length > 0 && selectedStatus !== null">
                                <div class="filter-label">&nbsp;</div>
                                <download-csv
                                  class="btn download-btn glass-download-btn"
                                  :data="get_csv_data()"
                                  :name="get_csv_filename()"
                                >
                                  DOWNLOAD EXCEL
                                </download-csv>
                              </div>

                              <!-- Clear Filters Button -->
                              <div class="filter-group" v-if="dateRange && dateRange.length === 2">
                                <div class="filter-label">&nbsp;</div>
                                <b-button
                                  variant="outline-danger"
                                  size="lg"
                                  @click="clearSelections"
                                  class="clear-btn glass-clear-btn"
                                >
                                  CLEAR
                                </b-button>
                              </div>
                            </div>
                          </b-alert>
                        </b-collapse>
                    </div>
                </div>

                <!-- Rest of your table code remains the same -->
                <div style="width: 100%; padding: 5px; min-height: 200px;">
                    <b-card no-body class="glass-table-card" style="min-height: 200px;">
                        <!-- Bulk Action Bar -->
                        <div v-if="selectedItems.length > 0" class="bulk-action-bar glass-card">
                            <div class="bulk-action-content">
                                <span class="selected-count">{{ selectedItems.length }} item(s) selected</span>
                                <div class="bulk-actions">
                                    <b-form-select
                                        v-model="bulkActionState"
                                        class="bulk-state-select glass-select"
                                        :options="getBulkStateOptions()"
                                    >
                                        <template #first>
                                            <b-form-select-option :value="null">Change Status to...</b-form-select-option>
                                        </template>
                                    </b-form-select>
                                    <b-button
                                        variant="primary"
                                        @click="applyBulkStateUpdate"
                                        :disabled="!bulkActionState || isBulkUpdating"
                                        class="apply-bulk-btn glass-btn"
                                    >
                                        {{ isBulkUpdating ? 'Updating...' : 'Apply to Selected' }}
                                    </b-button>
                                    <b-button
                                        variant="outline-secondary"
                                        @click="clearSelection"
                                        class="clear-selection-btn"
                                        :disabled="isBulkUpdating"
                                    >
                                        Clear Selection
                                    </b-button>
                                </div>
                            </div>
                        </div>

                        <div v-if="items_being_loaded == true">
                            <loading
                            :active="true"
                            :can-cancel="false"
                            :is-full-page="false">
                            </loading>
                        </div>

                        <div v-else-if="items_being_loaded == false">
                            <div v-if="items.length > 0" class="diver">
                                <table style="width: 100%;" class="glass-table">
                                    <thead>
                                        <tr style="font-size: 14px; text-align: center;">
                                            <td class="srr" style="width: 40px;">
                                                <b-form-checkbox
                                                    v-model="selectAll"
                                                    @change="toggleSelectAll"
                                                    class="select-all-checkbox"
                                                    :disabled="isBulkUpdating"
                                                ></b-form-checkbox>
                                            </td>
                                            <td class="srr" @click="sortby('invoice_id')" style="width: 100px;">
                                                INVOICE #
                                            </td>
                                            <td class="srr" @click="sortby('DATE')" style="width: 80px;">
                                               DATE
                                             </td>
                                            <td class="srr" @click="sortby('product_name')" style="width: 200px;">
                                                PRODUCT NAME
                                             </td>
                                            <td class="srr" @click="sortby('product_sku')" style="width: 100px;">
                                                PRODUCT SKU
                                             </td>
                                            <td class="srr" @click="sortby('order_type')" style="width: 100px;">
                                                ORDER TYPE
                                             </td>
                                            <td class="srr" @click="sortby('is_special')" style="width: 100px;">
                                                PRD TYPE
                                             </td>
                                            <td class="srr" style="width: 30px;">
                                                QTY
                                             </td>
                                            <td class="srr" @click="sortby('locsub')" style="width: 170px;">
                                               ITEM PULL FROM
                                             </td>
                                             <td class="srr" @click="sortby('ship_locsub')" style="width: 170px;">
                                                DROP LOCATION
                                             </td>
                                             <td class="srr" @click="sortby('ship_locsub')" style="width: 170px;">
                                                DELIVERY LOC
                                             </td>
                                            <td class="srr" @click="sortby('truck', packet.trucksdict)" style="width: 100px;">
                                                DELIVERY TRUCK
                                             </td>
                                            <td class="srr" @click="sortby('state')" style="width: 120px;">
                                                STATUS
                                             </td>
                                            <td class="srr hidden-print" style="width: 70px;">
                                                COMMENTS
                                             </td>
                                         </tr>
                                    </thead>

                                    <tbody>
                                        <tr style="background: white; font-size: 14px; text-align: center;" v-for="item,idx in items" v-bind:key="idx" v-if="allowed(item) && item.quantity > 0">
                                            <td class="srrv">
                                                <b-form-checkbox
                                                    v-model="selectedItems"
                                                    :value="getItemIdentifier(item)"
                                                    @change="updateSelectAll"
                                                    class="item-checkbox"
                                                    :disabled="isBulkUpdating"
                                                ></b-form-checkbox>
                                            </td>
                                            <td class="srrv">
                                                {{ item.invoice_id }}
                                             </td>
                                             <td class="srrv">
                                                {{ item.pull_date }}
                                             </td>
                                            <td class="srrv">
                                                {{ ( (item.product_name || item.product_sku) || '').toUpperCase() }}
                                             </td>
                                            <td class="srrv">
                                                {{ ( item.product_sku || '').toUpperCase() }}
                                             </td>
                                               <td class="srrv">
                                                    <div v-if="item.order_type == 'home_delivery'">
                                                        <b-alert show variant="primary" style="padding: 2px; font-size: 11px; text-align: center;">HOME DELIVERY </b-alert>
                                                    </div>
                                                    <div v-else-if="item.order_type == 'store_pickup'">
                                                        <b-alert show variant="warning" style="padding: 2px; font-size: 11px; text-align: center;">STORE PICKUP</b-alert>
                                                    </div>
                                                    <div v-else-if="item.order_type == 'transfer_order'">
                                                        <b-alert show variant="info" style="padding: 2px; font-size: 11px; text-align: center;">STORE TRANSFER</b-alert>
                                                    </div>
                                                    <div v-else>
                                                        {{item.order_type}}
                                                    </div>
                                                 </td>
                                            <td class="srrv">
                                                <div v-if="item.is_special" style="background: pink; padding: 3px;">SPECIAL</div>
                                                <div v-else>REGULAR</div>
                                             </td>
                                            <td class="srrv">
                                                {{ item.quantity }}
                                             </td>
                                            <td class="srrv">
    {{ getLocationText(item.original_locsub || item.locsub) }}
</td>
<td class="srrv">
    {{ getLocationText(item.ship_locsub) }}
</td>
<td class="srrv">
    {{ getLocationText(item.drop_locsub) }}
</td>
                                            <td class="srrv">
                                                {{ packet.trucksdict[item.pickup_truck] }}
                                             </td>
                                            <td class="srrv">
                                                <b-form-select
                                                    size="sm"
                                                    :style="{background: get_background(item)}"
                                                    :options="check_states(item)" 
                                                    v-model="item.state"
                                                    v-on:change="update_invoice_item_state(item)"
                                                    :disabled="packet.locsubsdict[item.locsub] == 'OUT OF STOCK | OUT OF STOCK' || item.state == 30 || isBulkUpdating"
                                                ></b-form-select >
                                             </td>
                                            <td class="ipt_tdr srrv hidden-print">
                                                <button class="glass-comment-btn" @click="show_comments(item)" :disabled="isBulkUpdating">CMNT</button>
                                             </td>
                                         </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div v-else>
                                <b-alert show class="glass-empty-alert">NO ITEM FOUND</b-alert>
                            </div>
                        </div>
                    </b-card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    import mappings from '@/utilities/mappings'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import 'flatpickr/dist/flatpickr.css';
    import Requestor from '@/utilities/Requestor';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import ItemComments from '@/components/importables/ItemComments'
    import { BIconFunnelFill } from 'bootstrap-vue'

    export default {
        name: "ItemsToPull",
        components: { DatePicker, Loading, ItemComments },
        data: function(){
            let out = {
                items: [],
                dates: [],
                active_date:null,
                packet: {},
                items_being_loaded: null,
                dates_being_loaded: null,
                current_date: null,
                locations: [],
                locsub: null,
                states: [],
                dateRange: [],
                states_dict: mappings.states_dict,
                item_comments_invoice_id: null,
                item_comments_itemid: null,
                colors_dict: {},
                allowed_truck: null,
                allowed_locsub: null,
                locsubs: [],

                selectedStatus: 0,
                statusOptions: [
                    { value: 0, text: 'ORDERED' },
                    { value: 2, text: 'PULLED' },
                    { value: -2, text: 'CANT PULLED' },
                    { value: 14, text: 'SHIPPED TO WAREHOUSE' },
                    { value: 15, text: 'PENDING' }, 
                    { value: 3, text: 'PICKED' },
                    { value: -3, text: 'CANT PICKED' },
                    { value: 30, text: 'DROPPED' },
                    { value: -30, text: 'CANT DROPPED' }
                ],
                years: [
                    {value: 2022, text: 2022},
                    {value: 2023, text: 2023},
                    {value: 2024, text: 2024},
                    {value: 2025, text: 2025},
                    {value: 2026, text: 2026},
                    {value: 2027, text: 2027},
                    {value: 2028, text: 2028},
                    {value: 2029, text: 2029},
                    {value: 2030, text: 2030},
                ],
                months: [
                    {value: 1, text: 1},
                    {value: 2, text: 2},
                    {value: 3, text: 3},
                    {value: 4, text: 4},
                    {value: 5, text: 5},
                    {value: 6, text: 6},
                    {value: 7, text: 7},
                    {value: 8, text: 8},
                    {value: 9, text: 9},
                    {value: 10, text: 10},
                    {value: 11, text: 11},
                    {value: 12, text: 12},
                ],
                order_types: [
                    {value: null, text: "ALL"},
                    {value: "STORE_PICKUP", text: "STORE_PICKUP"},
                    {value: "HOME_DELIVERY", text: "HOME_DELIVERY"},
                ],
                picked_order_type: null,
                year: null,
                month: null,
                picked_date: null,
                picked_location_id: null,
                picked_pickup_truck: null,
                filtersVisible: false,
                isMobile: false,
                // Loading animation properties
                apiLoading: false,
                loadingMessage: 'Loading Items',
                loadingProgress: 0,
                currentTipIndex: 0,
                loadingInterval: null,
                tipInterval: null,
                msgInterval: null,
                apiCallStack: 0,
                tips: [
                    "📦 Fetching items to pull...",
                    "🚚 Loading delivery schedules...",
                    "📍 Syncing location data...",
                    "📊 Processing inventory...",
                    "🔄 Updating pull lists...",
                    "✨ Organizing items...",
                    "📈 Preparing data..."
                ],
                // Multi-select properties
                selectedItems: [],
                selectAll: false,
                bulkActionState: null,
                isBulkUpdating: false,
                bulkUpdateComplete: false
            }
            return out
        },

        watch: {
            dateRange: function(newRange, oldRange) {
                if (newRange && newRange.length === 2) {
                    this.items = [];
                    this.picked_date = null;
                    this.picked_location_id = null;
                    this.picked_order_type = null;
                    this.clearSelection();

                    if (this.selectedStatus !== null) {
                        this.get_items_by_status_and_date_range();
                    }
                }
            },

            selectedStatus: function(newStatus, oldStatus) {
                if (newStatus === null) {
                    this.items = [];
                    this.picked_date = null;
                    this.picked_location_id = null;
                    this.picked_order_type = null;
                    this.clearSelection();
                    return;
                }

                if (this.dateRange && this.dateRange.length === 2) {
                    this.get_items_by_status_and_date_range();
                }
            },

            selectedItems: function() {
                this.updateSelectAll();
            }
        },

        computed: {
            filteredItems: function() {
                return this.items.filter(item => this.allowed(item) && item.quantity > 0);
            }
        },

        methods: {
            // Multi-select methods
            getItemIdentifier: function(item) {
                return `${item.invoice_id}|${item.itemid}`;
            },

            toggleSelectAll: function() {
                if (this.selectAll) {
                    const allIds = this.filteredItems.map(item => this.getItemIdentifier(item));
                    this.selectedItems = allIds;
                } else {
                    this.selectedItems = [];
                }
            },

            updateSelectAll: function() {
                const filteredIds = this.filteredItems.map(item => this.getItemIdentifier(item));
                if (filteredIds.length === 0) {
                    this.selectAll = false;
                    return;
                }
                this.selectAll = filteredIds.every(id => this.selectedItems.includes(id));
            },

            clearSelection: function() {
                this.selectedItems = [];
                this.selectAll = false;
                this.bulkActionState = null;
            },

            getBulkStateOptions: function() {
                return this.get_allowed_states().filter(state => state.value !== 0);
            },

            getSelectedItemsData: function() {
                return this.items.filter(item => {
                    const identifier = this.getItemIdentifier(item);
                    return this.selectedItems.includes(identifier) && this.allowed(item) && item.quantity > 0;
                });
            },

            applyBulkStateUpdate: function() {
                if (!this.bulkActionState || this.isBulkUpdating) return;

                const selectedItems = this.getSelectedItemsData();
                if (selectedItems.length === 0) {
                    this.$bvToast.toast(
                        "No items selected for bulk update.",
                        {title: "Warning", autoHideDelay: 1500, variant:"warning"}
                    );
                    return;
                }

                this.$bvModal.msgBoxConfirm(
                    `Are you sure you want to update ${selectedItems.length} item(s) to status: ${this.getStatusText(this.bulkActionState)}?`,
                    {
                        title: 'Confirm Bulk Update',
                        size: 'sm',
                        buttonSize: 'sm',
                        okVariant: 'primary',
                        okTitle: 'YES',
                        cancelTitle: 'NO',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    }
                ).then(value => {
                    if (value) {
                        this.processBulkStateUpdate(selectedItems);
                    }
                }).catch(err => {
                    // Handle error or cancellation
                });
            },

            getStatusText: function(statusValue) {
                const option = this.statusOptions.find(s => s.value === statusValue);
                return option ? option.text : `Status ${statusValue}`;
            },

            processBulkStateUpdate: function(selectedItems) {
                this.isBulkUpdating = true;
                this.bulkUpdateComplete = false;
                
                // Show loading overlay for bulk update
                this.startApiLoading(`Updating ${selectedItems.length} items`);

                const that = this;
                let completed = 0;
                let successful = 0;
                let failed = 0;
                let errors = [];

                // Process items in batches
                const batchSize = 5; // Reduced batch size for better performance
                const batches = this.chunkArray(selectedItems, batchSize);

                let batchPromises = batches.map((batch, batchIndex) => {
                    return new Promise((resolve) => {
                        setTimeout(() => {
                            this.processBatch(batch, (batchSuccess, batchErrors) => {
                                successful += batchSuccess;
                                failed += batchErrors.length;
                                errors = errors.concat(batchErrors);
                                completed += batch.length;
                                
                                // Update progress - cap at 90% until complete
                                const progress = Math.min(Math.round((completed / selectedItems.length) * 90), 90);
                                that.loadingProgress = progress;
                                that.loadingMessage = `Updating ${completed}/${selectedItems.length} items...`;
                                
                                resolve();
                            });
                        }, batchIndex * 300);
                    });
                });

                Promise.all(batchPromises).then(() => {
                    // All batches complete
                    that.loadingProgress = 100;
                    that.loadingMessage = 'Finalizing...';
                    
                    // Small delay to show 100% before closing
                    setTimeout(() => {
                        // Force stop loading and clean up
                        that.stopApiLoading(true);
                        that.isBulkUpdating = false;
                        that.bulkUpdateComplete = true;
                        that.clearSelection();

                        // Show summary toast
                        let message = `Bulk update completed: ${successful} successful`;
                        if (failed > 0) {
                            message += `, ${failed} failed`;
                        }
                        that.$bvToast.toast(
                            message,
                            {
                                title: failed > 0 ? "Partial Success" : "Success",
                                autoHideDelay: 3000,
                                variant: failed > 0 ? "warning" : "success"
                            }
                        );

                        if (errors.length > 0) {
                            console.error('Bulk update errors:', errors);
                            const errorMessage = errors.slice(0, 3).join('\n');
                            if (errors.length > 3) {
                                that.$bvToast.toast(
                                    `${errorMessage}\n... and ${errors.length - 3} more errors`,
                                    {title: "Errors", autoHideDelay: 5000, variant:"danger"}
                                );
                            } else {
                                that.$bvToast.toast(
                                    errorMessage,
                                    {title: "Errors", autoHideDelay: 5000, variant:"danger"}
                                );
                            }
                        }

                        // Refresh the data to get latest states
                        that.get_items_by_status_and_date_range();
                    }, 500);
                }).catch(error => {
                    // Handle any unexpected errors
                    console.error('Bulk update error:', error);
                    that.stopApiLoading(false);
                    that.isBulkUpdating = false;
                    that.$bvToast.toast(
                        "An unexpected error occurred during bulk update.",
                        {title: "Error", autoHideDelay: 3000, variant:"danger"}
                    );
                });
            },

            processBatch: function(batch, callback) {
                let successful = 0;
                let errors = [];
                let completed = 0;
                const that = this;

                batch.forEach((item, index) => {
                    const originalState = item.state;
                    
                    // Update item state locally immediately
                    that.$set(item, 'state', that.bulkActionState);

                    let orderType = item.incoming_order_type || item.order_type || item.incoming_type || '';
                    let incomingType = '';
                    if (orderType === 'transfer_order' || orderType === 'store_transfer' || orderType === 'STORE_TRANSFER') {
                        incomingType = 'STORE_TRANSFER_ORDER';
                    } else if (orderType === 'damage_order' || orderType === 'damaged' || orderType === 'DAMAGE_ORDER') {
                        incomingType = 'DAMAGE_ORDER';
                    } else if (orderType === 'home_delivery' || orderType === 'store_pickup') {
                        incomingType = 'REGULAR_ORDER';
                    }

                    let data = {
                        invoice_id: item.invoice_id,
                        incoming_type: incomingType,
                        itemid: item.itemid,
                        state: that.bulkActionState,
                        changed_by: that.packet.userDetails.username,
                        product_sku: item.product_sku,
                        quantity: item.quantity,
                        bulk_update: true
                    };

                    setTimeout(() => {
                        Requestor.postAsync(
                            "/api/sales/update_invoice_item_state/",
                            data,
                            function(response) {
                                if (response.data.error) {
                                    that.$set(item, 'state', originalState);
                                    errors.push(`Item ${item.invoice_id}: ${response.data.error}`);
                                } else {
                                    successful++;
                                    // Update with any returned data
                                    if (response.data.result) {
                                        const updatedData = response.data.result;
                                        const index = that.items.findIndex(i => 
                                            i.invoice_id === item.invoice_id && i.itemid === item.itemid
                                        );
                                        if (index !== -1) {
                                            that.$set(that.items, index, {...that.items[index], ...updatedData});
                                        }
                                    }
                                }
                                completed++;
                                
                                if (completed === batch.length) {
                                    callback(successful, errors);
                                }
                            },
                            function(error) {
                                that.$set(item, 'state', originalState);
                                errors.push(`Item ${item.invoice_id}: Network error`);
                                completed++;
                                
                                if (completed === batch.length) {
                                    callback(successful, errors);
                                }
                            }
                        );
                    }, index * 150);
                });
            },

            chunkArray: function(array, size) {
                const chunks = [];
                for (let i = 0; i < array.length; i += size) {
                    chunks.push(array.slice(i, i + size));
                }
                return chunks;
            },

            // Loading animation methods - FIXED
            startApiLoading: function(message = 'Loading Items') {
                // Clear any existing loading state
                this.stopApiLoading(true);
                
                this.apiCallStack = 1;
                this.apiLoading = true;
                this.loadingMessage = message;
                this.loadingProgress = 0;
                this.currentTipIndex = 0;
                
                // Clear any existing intervals
                if (this.loadingInterval) clearInterval(this.loadingInterval);
                if (this.tipInterval) clearInterval(this.tipInterval);
                if (this.msgInterval) clearInterval(this.msgInterval);
                
                this.loadingInterval = setInterval(() => {
                    if (this.loadingProgress < 90) {
                        this.loadingProgress += Math.random() * 8;
                        if (this.loadingProgress > 90) this.loadingProgress = 90;
                    }
                }, 300);
                
                this.tipInterval = setInterval(() => {
                    if (this.currentTipIndex < this.tips.length - 1) {
                        this.currentTipIndex++;
                    } else {
                        this.currentTipIndex = 0;
                    }
                }, 2500);
                
                let messages = ['Loading Items', 'Fetching Data', 'Processing Records', 'Updating List', 'Finalizing'];
                let msgIndex = 0;
                this.msgInterval = setInterval(() => {
                    if (msgIndex < messages.length - 1) {
                        msgIndex++;
                        this.loadingMessage = messages[msgIndex];
                    }
                }, 2000);
            },
            
            stopApiLoading: function(success = true) {
                // Clear all intervals
                if (this.loadingInterval) {
                    clearInterval(this.loadingInterval);
                    this.loadingInterval = null;
                }
                if (this.tipInterval) {
                    clearInterval(this.tipInterval);
                    this.tipInterval = null;
                }
                if (this.msgInterval) {
                    clearInterval(this.msgInterval);
                    this.msgInterval = null;
                }
                
                this.apiCallStack = 0;
                
                if (success) {
                    this.loadingProgress = 100;
                    this.loadingMessage = 'Complete!';
                    
                    setTimeout(() => {
                        this.apiLoading = false;
                        this.loadingProgress = 0;
                    }, 400);
                } else {
                    this.apiLoading = false;
                    this.loadingProgress = 0;
                }
            },

            getLocationText: function(locsubKey) {
                if (!locsubKey) return 'N/A';
                
                const cleanKey = locsubKey.toString().trim();
                const locationText = this.packet.locsubsdict[cleanKey];
                
                if (locationText) {
                    return locationText;
                } else {
                    const altKeys = [cleanKey];
                    
                    if (cleanKey.includes('|')) {
                        altKeys.push(cleanKey.replace('|', ' | '));
                        altKeys.push(cleanKey.replace(/\s*\|\s*/, '|'));
                    }
                    
                    for (const altKey of altKeys) {
                        if (this.packet.locsubsdict[altKey]) {
                            return this.packet.locsubsdict[altKey];
                        }
                    }
                    
                    if (cleanKey.includes('|')) {
                        const [locationId, sublocationId] = cleanKey.split('|');
                        return `Location ${locationId.trim()}-${sublocationId.trim()}`;
                    }
                    return cleanKey;
                }
            },
            
            handleResize: function() {
                this.isMobile = window.innerWidth < 768
            },
            
            setDefaultDateRange: function() {
                const today = moment().format('YYYY-MM-DD');
                const tomorrow = moment().add(1, 'days').format('YYYY-MM-DD');
                this.dateRange = [today, tomorrow];
            },

            onDatepickerContext: function(ctx) {
                console.log('Datepicker context:', ctx);
            },

            clearSelections: function() {
                this.dateRange = [];
                this.selectedStatus = null;
                this.items = [];
                this.picked_date = null;
                this.picked_location_id = null;
                this.picked_order_type = null;
                this.clearSelection();

                setTimeout(() => {
                    this.setDefaultDateRange();
                    this.selectedStatus = 0;
                }, 100);
            },

            get_items_by_status_and_date_range: function() {
                let path = "/api/sales/get_items_by_status/"
                let that = this;
                
                // Don't show loading overlay for refresh after bulk update
                if (!this.bulkUpdateComplete) {
                    this.startApiLoading('Fetching Items');
                }
                this.clearSelection();

                if (!this.dateRange || this.dateRange.length !== 2 || this.selectedStatus === null) {
                    if (!this.bulkUpdateComplete) {
                        this.stopApiLoading();
                    }
                    return;
                }

                let data = {
                    status: this.selectedStatus,
                    start_date: this.dateRange[0],
                    end_date: this.dateRange[1]
                };

                if (this.packet.userDetails.properties && this.packet.userDetails.properties.location_id) {
                    data.location_id = this.packet.userDetails.properties.location_id;
                }

                let s = function(response) {
                    if (response.data.result){
                        that.items = response.data.result;
                        that.picked_date = null;
                        that.picked_location_id = null;
                        that.picked_order_type = null;
                        that.clearSelection();
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error || "No items found with selected criteria",
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                    
                    // Only stop loading if not a bulk update refresh
                    if (!that.bulkUpdateComplete) {
                        that.stopApiLoading();
                    } else {
                        // Reset bulk update flag
                        that.bulkUpdateComplete = false;
                        // Force close any lingering loading state
                        that.apiLoading = false;
                        that.loadingProgress = 0;
                    }
                }

                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading items.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.items_being_loaded = false;
                    
                    if (!that.bulkUpdateComplete) {
                        that.stopApiLoading();
                    } else {
                        that.bulkUpdateComplete = false;
                        that.apiLoading = false;
                        that.loadingProgress = 0;
                    }
                }

                this.items = [];
                this.items_being_loaded = true;
                Requestor.postAsync(path, data, s, f);
            },

            applyDateFilter: function() {
                this.clearSelection();
            },

            applyLocationFilter: function() {
                this.clearSelection();
            },

            applyOrderTypeFilter: function() {
                this.clearSelection();
            },

            get_allowed_states: function(){
                let userrole = this.packet.userDetails.userrole;
                let allowedStates = mappings.states.filter(function(d){
                    return [2, -2, 14, 15, 3, -3, 30, -30].includes(d.value);
                });

                if (userrole == "admin" || userrole == "officeuser"){
                    return allowedStates.map(function(d){ d.disabled = false; return d; });
                }
                else {
                    if (userrole == "warehouseuser" || userrole == "warehousemanager"){
                        return allowedStates.map(function(d){ d.disabled = false; return d; });
                    }
                    else {
                        return allowedStates.map(function(d){ d.disabled = true; return d; });
                    }
                }
            },

            check_states: function(item) {
                let userrole = this.packet.userDetails.userrole;
                const allStates = mappings.states;
                
                const isStateSelectable = (stateValue) => {
                    if (userrole === "admin") {
                        return true;
                    }
                    
                    if (item.state === 0) {
                        return [0, 2, -2, 14, 15].includes(stateValue);
                    } else if ([2, -2].includes(item.state)) {
                        return [2, -2, 14, 15].includes(stateValue);
                    } else if (item.state === 14) {
                        return [14, 15].includes(stateValue);
                    } else if (item.state === 15) {
                        return [15, 3, -3].includes(stateValue);
                    }
                    
                    return stateValue === item.state;
                };
                
                return allStates.map(state => {
                    const selectable = isStateSelectable(state.value);
                    return {
                        ...state,
                        disabled: !selectable,
                        text: selectable ? state.text : `${state.text} (Not Available)`
                    };
                });
            },

            get_csv_filename: function(){
                let picked_date = this.picked_date || 'all_dates';
                let status = 'all_status';
                if (this.selectedStatus !== null) {
                    const statusOption = this.statusOptions.find(s => s.value === this.selectedStatus);
                    status = statusOption ? statusOption.text : 'all_status';
                }
                return `PULLIST_${status}_${picked_date}.csv`;
            },

            allowed_pull_location: function(item) {
                let userrole = this.packet.userDetails.userrole;
                let userLocationId = this.packet.userDetails.properties.location_id;

                const getItemPullLocationId = (item) => {
                    if (item.original_locsub && item.original_locsub.includes('|')) {
                        return parseInt(item.original_locsub.split('|')[0]);
                    }
                    if (item.locsub && item.locsub.includes('|')) {
                        return parseInt(item.locsub.split('|')[0]);
                    }
                    return null;
                };

                const itemPullLocationId = getItemPullLocationId(item);

                if (userrole == 'admin' || userrole == 'officeuser') {
                    if (this.picked_location_id) {
                        return itemPullLocationId === this.picked_location_id;
                    }
                    return true;
                }
                else {
                    if (userLocationId) {
                        return itemPullLocationId === userLocationId;
                    } else {
                        return item.is_main_warehouse;
                    }
                }
            },

            allowed_order_type: function(item){
                let status = true;
                if (this.picked_order_type){
                    if (item.order_type && item.order_type.toUpperCase() === this.picked_order_type.toUpperCase()){
                        status = true;
                    }
                    else {
                        status = false;
                    }
                }
                return status;
            },

            allowed_date: function(item) {
                if (!this.picked_date) {
                    return true;
                }
                return item.pull_date === this.picked_date;
            },

            allowed: function(item){
                let userrole = this.packet.userDetails.userrole;

                if (userrole !== "admin" && userrole !== "") {
                    if (![0, 2, -2, 14, 15, 3, -3, 30, -30].includes(item.state)) {
                        return false;
                    }
                }

                let pull_location_status = this.allowed_pull_location(item);
                let order_type_status = this.allowed_order_type(item);
                let date_status = this.allowed_date(item);

                return (pull_location_status && order_type_status && date_status);
            },

            get_background: function(item){
                let state = item.state;
                let bg = 'white'
                if (state == 0){
                    bg = 'white';
                }
                else if (state == 2){
                    bg = 'lightgreen'
                }
                else if (state == -2) {
                    bg = 'yellow'
                }
                else if (state == 14) {
                    bg = 'lightblue'
                }
                else if (state == 15) {
                    bg = 'lightcoral'
                }
                else if (state == 3) {
                    bg = '#90EE90'
                }
                else if (state == -3) {
                    bg = '#FFD700'
                }
                else if (state == 30) {
                    bg = '#DDA0DD'
                }
                else if (state == -30) {
                    bg = '#FF6B6B'
                }
                return bg
            },

            toggle_details: function(item){
                item.show_details = (!item.show_details)
            },

            show_comments: function(item){
                this.item_comments_invoice_id = item.invoice_id;
                this.item_comments_itemid= item.itemid;
                this.$bvModal.show("modal-itp-comments");
            },

            update_invoice_item_state: function(item){
                let path = "/api/sales/update_invoice_item_state/"
                let that = this;

                let orderType = item.incoming_order_type || item.order_type || item.incoming_type || '';
                let incomingType = '';
                if (orderType === 'transfer_order' || orderType === 'store_transfer' || orderType === 'STORE_TRANSFER') {
                    incomingType = 'STORE_TRANSFER_ORDER';
                } else if (orderType === 'damage_order' || orderType === 'damaged' || orderType === 'DAMAGE_ORDER') {
                    incomingType = 'DAMAGE_ORDER';
                } else if (orderType === 'home_delivery' || orderType === 'store_pickup') {
                    incomingType = 'REGULAR_ORDER';
                }
                
                const originalState = item.state;
                
                let data = {
                    invoice_id: item.invoice_id, 
                    incoming_type: incomingType,
                    itemid: item.itemid, 
                    state: item.state, 
                    changed_by: this.packet.userDetails.username,  
                    product_sku: item.product_sku, 
                    quantity: item.quantity
                }

                let s = function(response) {
                    if (response.data.error){
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.$set(item, 'state', originalState);
                    }
                    else {
                        that.$bvToast.toast(
                            "Success updating item state.",
                            {title: "Success", autoHideDelay: 1500, variant:"success"}
                        );
                        
                        if (response.data.result) {
                            const updatedItem = response.data.result;
                            const index = that.items.findIndex(i => 
                                i.invoice_id === item.invoice_id && i.itemid === item.itemid
                            );
                            if (index !== -1) {
                                that.$set(that.items, index, {...that.items[index], ...updatedItem});
                            }
                        }
                    }
                }

                let f = function(error) {
                    console.log("Error updating item state:", error)
                    that.$bvToast.toast(
                        "Error updating item state.",
                        {title: "Error", autoHideDelay: 1500, variant:"danger"}
                    );
                    that.$set(item, 'state', originalState);
                }
                
                Requestor.postAsync(path, data, s, f);
            },

            filter_order_types: function() {
                const itemsToUse = this.getItemsForCurrentFilters();
                const orderTypeCounts = {};
                itemsToUse.forEach(item => {
                    if (item.order_type) {
                        orderTypeCounts[item.order_type] = (orderTypeCounts[item.order_type] || 0) + 1;
                    }
                });

                const orderTypeOptions = Object.keys(orderTypeCounts).map(orderType => {
                    return {
                        value: orderType,
                        text: `${orderType.toUpperCase().replace('_', ' ')} (${orderTypeCounts[orderType]})`
                    };
                });

                return orderTypeOptions;
            },

            filter_dates: function() {
                const dateCounts = {};
                this.items.forEach(item => {
                    if (item.pull_date) {
                        dateCounts[item.pull_date] = (dateCounts[item.pull_date] || 0) + 1;
                    }
                });

                const dateOptions = Object.keys(dateCounts).map(date => {
                    return {
                        value: date,
                        text: `${date} (${dateCounts[date]})`
                    };
                });

                dateOptions.sort((a, b) => new Date(b.value) - new Date(a.value));
                return dateOptions;
            },

            filter_locations: function() {
                const itemsToUse = this.getItemsForCurrentFilters();

                const getLocationId = (item) => {
                    if (item.original_locsub && item.original_locsub.includes('|')) {
                        return parseInt(item.original_locsub.split('|')[0]);
                    }
                    if (item.locsub && item.locsub.includes('|')) {
                        return parseInt(item.locsub.split('|')[0]);
                    }
                    return null;
                };

                const getLocationSubText = (item) => {
                    if (item.original_locsub && this.packet.locsubsdict[item.original_locsub]) {
                        return this.packet.locsubsdict[item.original_locsub];
                    }
                    if (item.locsub && this.packet.locsubsdict[item.locsub]) {
                        return this.packet.locsubsdict[item.locsub];
                    }
                    return 'Unknown Location';
                };

                const locationMap = {};
                itemsToUse.forEach(item => {
                    const locationId = getLocationId(item);
                    if (locationId && !isNaN(locationId)) {
                        const locationText = getLocationSubText(item);
                        if (!locationMap[locationId]) {
                            locationMap[locationId] = {
                                text: locationText,
                                count: 0
                            };
                        }
                        locationMap[locationId].count += 1;
                    }
                });

                const locationOptions = Object.keys(locationMap).map(locationId => {
                    const locationData = locationMap[locationId];
                    return {
                        value: parseInt(locationId),
                        text: `${locationData.text} (${locationData.count})`
                    };
                });

                locationOptions.sort((a, b) => a.text.localeCompare(b.text));
                return locationOptions;
            },

            getItemsForCurrentFilters: function() {
                if (!this.picked_date) {
                    return this.items;
                }
                return this.items.filter(item => item.pull_date === this.picked_date);
            },

            get_csv_data: function(){
                let data = []
                let that = this;
                let items = this.items.filter(item => this.allowed(item));

                if (items.length > 0){
                    for (var j=0; j<items.length; j++){
                        let element = items[j];
                        let k = {};
                        k["INVOICE"] = element.invoice_id;
                        k["PRODUCT_NAME"] = element.product_name;
                        k["SKU"] = element.product_sku;
                        k["ORDER_TYPE"] = element.order_type;
                        k["PRODUCT_TYPE"] = (element.is_special ? 'SPECIAL' : 'REGULAR');
                        k["QUANTITY"] = element.quantity;
                        k["PULL_FROM"] = this.packet.locsubsdict[element.locsub];
                        k["DELIVERY_TRUCK"] = this.packet.trucksdict[element.truck];
                        data.push(k)
                    }
                }
                return data
            },

            sortby: function(field) {
                this.items.sort((a, b) => {
                    if (a[field] < b[field]) return -1;
                    if (a[field] > b[field]) return 1;
                    return 0;
                });
            }
        },

        created: function(){
            let that = this;
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.locsubs = this.packet.locsubs;
            if (this.packet.userDetails.properties.location_id){
                let location_id = this.packet.userDetails.properties.location_id;
                this.locsubs = this.locsubs.filter(function(d){return d.location_id == location_id})
            }
            this.states = this.get_allowed_states();
            this.setDefaultDateRange();
            this.selectedStatus = 0;
        },

        mounted: function() {
            if (this.dateRange && this.dateRange.length === 2 && this.selectedStatus !== null) {
                setTimeout(() => {
                    this.get_items_by_status_and_date_range();
                }, 100);
            }
            this.handleResize();
            window.addEventListener('resize', this.handleResize);
        },
        
        beforeDestroy() {
            window.removeEventListener('resize', this.handleResize);
            // Clear any pending intervals
            if (this.loadingInterval) clearInterval(this.loadingInterval);
            if (this.tipInterval) clearInterval(this.tipInterval);
            if (this.msgInterval) clearInterval(this.msgInterval);
        },
    }
</script>

<style scoped>
    /* ... (keep all existing styles) ... */
    .glass-theme {
        position: relative;
        background: transparent !important;
        min-height: 100vh;
        padding: 24px;
    }

    .glass-theme::before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-image: url('https://m.media-amazon.com/images/I/81eSegKonhL._AC_SL1500_.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        filter: blur(10px);
        opacity: 0.5;
        z-index: -2;
        transform: scale(1.1);
    }

    .glass-card,
    .filter-container,
    .glass-table-card,
    .glass-empty-alert {
        background: rgba(255, 255, 255, 0.85) !important;
        backdrop-filter: blur(10px) !important;
        border: 1px solid rgba(255, 255, 255, 0.3) !important;
        border-radius: 20px !important;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05) !important;
    }

    .bulk-action-bar {
        padding: 12px 20px;
        margin-bottom: 15px;
        border-radius: 12px;
        background: rgba(255, 255, 255, 0.95) !important;
        border: 2px solid rgba(66, 153, 225, 0.3) !important;
        box-shadow: 0 2px 12px rgba(66, 153, 225, 0.1) !important;
    }

    .bulk-action-content {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 15px;
    }

    .selected-count {
        font-weight: 600;
        color: #2d3748;
        margin-right: 10px;
        font-size: 14px;
    }

    .bulk-actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
        flex: 1;
    }

    .bulk-state-select {
        width: 200px !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        border: 2px solid #495057 !important;
        border-radius: 8px !important;
        background: white !important;
        height: 40px !important;
    }

    .apply-bulk-btn {
        height: 40px !important;
        font-size: 13px !important;
        font-weight: 600 !important;
        padding: 0 20px !important;
        background: linear-gradient(135deg, #4299e1, #3182ce) !important;
        border: none !important;
        color: white !important;
        border-radius: 8px !important;
        transition: all 0.3s ease !important;
    }

    .apply-bulk-btn:hover:not(:disabled) {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(66, 153, 225, 0.3) !important;
    }

    .apply-bulk-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .clear-selection-btn {
        height: 40px !important;
        font-size: 13px !important;
        border: 2px solid #e2e8f0 !important;
        border-radius: 8px !important;
        color: #4a5568 !important;
        background: transparent !important;
        transition: all 0.3s ease !important;
    }

    .clear-selection-btn:hover:not(:disabled) {
        background: #f7fafc !important;
        border-color: #cbd5e0 !important;
    }

    .clear-selection-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .select-all-checkbox,
    .item-checkbox {
        transform: scale(1.2);
        margin: 0;
        cursor: pointer;
    }

    .select-all-checkbox >>> .custom-control-label::before,
    .item-checkbox >>> .custom-control-label::before {
        border-radius: 4px !important;
    }

    .diver {
        overflow: auto;
        width: 100%;
        height: 800px;
    }

    .srr {
        font-size: 12px;
        text-align: center;
        font-weight: bold;
        background: rgb(60, 60, 60);
        color: white;
        border: 1px solid #ffffff;
        padding: 3px;
    }

    .srrv {
        font-size: 13px;
        text-align: center;
        background: white;
        border: 1px solid #010101;
        padding: 5px;
    }

    table {
        table-layout: fixed;
        width: 100%;
    }

    .filter-container {
        padding: 15px;
        background: #f8f9fa !important;
        border: 1px solid #dee2e6;
        border-radius: 8px;
    }

    .filter-row {
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
        align-items: flex-end;
    }

    .filter-group {
        display: flex;
        flex-direction: column;
        min-width: 180px;
    }

    .filter-label {
        font-weight: bold;
        font-size: 12px;
        margin-bottom: 5px;
        color: #495057;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .filter-select {
        width: 180px !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        border: 2px solid #495057 !important;
        border-radius: 6px !important;
        background: white !important;
        height: 45px !important;
    }

    .filter-select-wide {
        width: 250px !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        border: 2px solid #495057 !important;
        border-radius: 6px !important;
        background: white !important;
        height: 45px !important;
    }

    .filter-datepicker {
        width: 220px !important;
        border: 2px solid #495057 !important;
        border-radius: 6px !important;
    }

    .filter-datepicker >>> .mx-input {
        height: 45px !important;
        border: none !important;
        font-size: 14px !important;
        font-weight: 600 !important;
        border-radius: 6px !important;
    }

    .glass-input >>> .mx-input,
    .glass-select,
    .filter-select,
    .filter-select-wide {
        background: rgba(255, 255, 255, 0.9) !important;
        backdrop-filter: blur(5px) !important;
        border: 2px solid rgba(0, 0, 0, 0.1) !important;
        border-radius: 12px !important;
        transition: all 0.3s ease !important;
    }

    .glass-input >>> .mx-input:hover,
    .glass-select:hover,
    .filter-select:hover,
    .filter-select-wide:hover {
        background: rgba(255, 255, 255, 0.95) !important;
        border-color: rgba(0, 0, 0, 0.2) !important;
    }

    .glass-input >>> .mx-input:focus,
    .glass-select:focus,
    .filter-select:focus,
    .filter-select-wide:focus {
        border-color: #4299e1 !important;
        box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1) !important;
    }

    .glass-download-btn {
        background: linear-gradient(135deg, #28a745, #20c997) !important;
        border: none !important;
        color: white !important;
        transition: all 0.3s ease !important;
    }

    .glass-download-btn:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3);
    }

    .glass-clear-btn {
        background: rgba(220, 53, 69, 0.1) !important;
        border: 2px solid #dc3545 !important;
        color: #dc3545 !important;
        transition: all 0.3s ease !important;
    }

    .glass-clear-btn:hover {
        background: #dc3545 !important;
        color: white !important;
        transform: translateY(-2px);
        box-shadow: 0 4px 15px rgba(220, 53, 69, 0.3);
    }

    .glass-comment-btn {
        background: rgba(0, 123, 255, 0.1);
        border: 1px solid rgba(0, 123, 255, 0.3);
        color: #007bff;
        padding: 5px 10px;
        border-radius: 8px;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .glass-comment-btn:hover:not(:disabled) {
        background: rgba(0, 123, 255, 0.2);
        transform: scale(1.05);
    }

    .glass-comment-btn:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    .glass-table {
        border-collapse: separate;
        border-spacing: 0;
        width: 100%;
    }

    .glass-table thead tr {
        background: rgba(60, 60, 60, 0.9) !important;
        backdrop-filter: blur(5px);
    }

    .glass-table tbody tr {
        background: rgba(255, 255, 255, 0.95);
        transition: all 0.3s ease;
    }

    .glass-table tbody tr:hover {
        background: rgba(255, 255, 255, 0.7);
        transform: scale(1.01);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }

    select option:disabled {
        color: #6c757d !important;
        font-style: italic;
        background-color: #f8f9fa !important;
    }

    select option {
        padding: 8px !important;
    }

    select option[disabled] {
        background-color: #e9ecef !important;
        border-bottom: 1px solid #dee2e6;
    }

    .download-btn {
        border: 2px solid #28a745 !important;
        background: #28a745 !important;
        color: white !important;
        padding: 10px 15px !important;
        font-size: 14px !important;
        font-weight: bold !important;
        border-radius: 6px !important;
        height: 45px !important;
        text-decoration: none !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        transition: all 0.3s ease !important;
    }

    .download-btn:hover {
        background: #218838 !important;
        border-color: #1e7e34 !important;
        transform: translateY(-1px);
        box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    }

    .clear-btn {
        height: 45px !important;
        font-size: 14px !important;
        font-weight: bold !important;
        border: 2px solid #dc3545 !important;
        border-radius: 6px !important;
        padding: 10px 15px !important;
    }

    .clear-btn:hover {
        background: #dc3545 !important;
        color: white !important;
    }

    .ipt_tdr {
        font-family: roboto !important;
        font-size: 13px;
        background: white;
    }

    .pcol {
        padding: 5px;
    }

    .card-body {
        padding: 5px;
    }

    .loading-overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.85);
        backdrop-filter: blur(20px);
        z-index: 2000;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loading-overlay-enter-active {
        animation: fadeIn 0.3s ease;
    }

    .loading-overlay-leave-active {
        animation: fadeOut 0.3s ease;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    @keyframes fadeOut {
        from { opacity: 1; }
        to { opacity: 0; }
    }

    .loading-card {
        background: linear-gradient(135deg, rgba(255, 255, 255, 0.95), rgba(245, 245, 245, 0.95));
        border-radius: 24px;
        padding: 48px 56px;
        text-align: center;
        box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
        animation: cardPop 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
        max-width: 450px;
        width: 90%;
    }

    @keyframes cardPop {
        from {
            opacity: 0;
            transform: scale(0.8);
        }
        to {
            opacity: 1;
            transform: scale(1);
        }
    }

    .loading-animation {
        margin-bottom: 32px;
    }

    .loading-ring {
        position: relative;
        width: 100px;
        height: 100px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .ring {
        position: absolute;
        width: 100%;
        height: 100%;
        border: 4px solid transparent;
        border-radius: 50%;
        animation: ringRotate 1.5s linear infinite;
    }

    .ring:nth-child(1) {
        border-top-color: #4299e1;
        border-left-color: #4299e1;
        animation-duration: 1s;
    }

    .ring:nth-child(2) {
        border-right-color: #48bb78;
        border-bottom-color: #48bb78;
        width: 80%;
        height: 80%;
        top: 10%;
        left: 10%;
        animation-duration: 1.2s;
        animation-direction: reverse;
    }

    .ring:nth-child(3) {
        border-left-color: #ed8936;
        border-bottom-color: #ed8936;
        width: 60%;
        height: 60%;
        top: 20%;
        left: 20%;
        animation-duration: 0.8s;
    }

    @keyframes ringRotate {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

    .loading-logo {
        font-size: 32px;
        font-weight: bold;
        animation: logoPulse 1.5s ease-in-out infinite;
        z-index: 1;
    }

    .loading-logo i {
        font-size: 40px;
        background: linear-gradient(135deg, #4299e1, #48bb78);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
    }

    @keyframes logoPulse {
        0%, 100% { transform: scale(1); opacity: 0.7; }
        50% { transform: scale(1.1); opacity: 1; }
    }

    .loading-text {
        margin-bottom: 24px;
    }

    .loading-text h3 {
        color: #2d3748;
        font-size: 1.3rem;
        margin-bottom: 8px;
        display: inline-block;
    }

    .loading-dots {
        display: inline-flex;
        margin-left: 8px;
    }

    .loading-dots .dot {
        width: 6px;
        height: 6px;
        background: #4299e1;
        border-radius: 50%;
        margin: 0 2px;
        animation: dotBounce 1.4s ease-in-out infinite;
    }

    .loading-dots .dot:nth-child(1) { animation-delay: 0s; }
    .loading-dots .dot:nth-child(2) { animation-delay: 0.2s; }
    .loading-dots .dot:nth-child(3) { animation-delay: 0.4s; }

    @keyframes dotBounce {
        0%, 60%, 100% { transform: translateY(0); }
        30% { transform: translateY(-8px); }
    }

    .loading-progress {
        width: 100%;
        height: 4px;
        background: #e2e8f0;
        border-radius: 4px;
        overflow: hidden;
        margin-bottom: 20px;
    }

    .progress-bar {
        height: 100%;
        background: linear-gradient(90deg, #4299e1, #48bb78, #ed8936, #4299e1);
        background-size: 200% 100%;
        animation: progressShine 1.5s linear infinite;
        transition: width 0.3s ease;
        border-radius: 4px;
    }

    @keyframes progressShine {
        0% { background-position: 200% 0; }
        100% { background-position: -200% 0; }
    }

    .loading-tips {
        margin-top: 20px;
    }

    .tip-text {
        color: #718096;
        font-size: 0.9rem;
        animation: tipFade 0.5s ease;
    }

    @keyframes tipFade {
        from {
            opacity: 0;
            transform: translateY(10px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (max-width: 768px) {
        .glass-theme {
            padding: 16px;
        }

        .diver {
            height: auto;
            overflow-x: auto;
            overflow-y: auto;
        }
        
        .filter-row {
            display: grid;
            grid-template-columns: 1fr 1fr;
        }

        .filter-group {
            min-width: 100%;
        }

        .filter-select,
        .filter-select-wide,
        .filter-datepicker {
            width: 100% !important;
        }

        .bulk-action-content {
            flex-direction: column;
            align-items: stretch;
        }

        .bulk-actions {
            flex-direction: column;
            align-items: stretch;
        }

        .bulk-state-select {
            width: 100% !important;
        }
    }

    @media (max-width: 480px) {
        .filter-row {
            display: flex;
            flex-direction: column;
            align-items: stretch;
        }
        
        .loading-card {
            padding: 32px 24px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/IncomingOutGoing/ItemsToPull.vue